import { Controller } from "@hotwired/stimulus"
import { showToast } from "../utils/show_toast"
import { patchImageAltText } from "../utils/patch_image_alt_text"

function trimmedAlt(s) {
  return String(s ?? "").trim()
}

export default class extends Controller {
  static targets = ["saveAllButton"]

  async saveAll(event) {
    event.preventDefault()
    const btn = this.hasSaveAllButtonTarget ? this.saveAllButtonTarget : event.currentTarget
    if (!btn || btn.disabled) return

    const inputs = Array.from(this.element.querySelectorAll("[data-image-alt-input]")).filter(
      (el) => el.dataset.updateUrl && !el.disabled
    )
    if (inputs.length === 0) {
      showToast("No alt text fields to save yet", "error")
      return
    }

    const changed = inputs.filter((el) => trimmedAlt(el.value) !== trimmedAlt(el.defaultValue))
    if (changed.length === 0) {
      showToast("No changes to save")
      return
    }

    const icon = btn.querySelector("i")
    const prevIconClass = icon?.className
    btn.disabled = true
    if (prevIconClass) icon.className = "fa-solid fa-spinner animate-spin text-[0.8rem] leading-none"

    const results = await Promise.allSettled(
      changed.map((input) => patchImageAltText(input.dataset.updateUrl, input.value))
    )

    let ok = 0
    let fail = 0
    changed.forEach((input, i) => {
      const r = results[i]
      if (r.status === "fulfilled" && r.value.ok) {
        ok++
        input.defaultValue = trimmedAlt(input.value)
      } else {
        fail++
      }
    })

    btn.disabled = false
    if (prevIconClass && icon) icon.className = prevIconClass

    if (fail === 0) {
      showToast(ok === 1 ? "Alt text saved" : `Alt text saved for ${ok} images`)
    } else if (ok === 0) {
      showToast("Failed to save alt text", "error")
    } else {
      showToast(`Saved ${ok}; ${fail} failed`, "error")
    }
  }
}
